// BUILD-042 — Unified employee workspace. Small internal sub-tab strip used WITHIN a single
// section's content pane (e.g. Personal & Contacts -> Personal details/Contact details/
// Emergency contacts/Immigration), per the decision's "Single right-hand content section with
// useful internal sub-tabs; no long stack of every form." Generic — callers supply the tab
// labels/keys and render whichever panel is active; this component holds no section meaning of
// its own.
import { useState, type ReactNode } from 'react';

export function SubTabs<K extends string>({
  tabs, initial, children,
}: {
  tabs: { key: K; label: string }[];
  initial: K;
  children: (active: K) => ReactNode;
}) {
  const [active, setActive] = useState<K>(initial);
  return (
    <div>
      <div role="tablist" aria-label="Section views" className="flex flex-wrap gap-1 border-b border-gray-100 pb-2 mb-4">
        {tabs.map((t) => {
          const selected = t.key === active;
          return (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={selected}
              onClick={() => setActive(t.key)}
              className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${
                selected ? 'bg-[#EDF5FC] text-[#176A9B]' : 'text-gray-500 hover:bg-gray-50'
              }`}
            >
              {t.label}
            </button>
          );
        })}
      </div>
      {children(active)}
    </div>
  );
}
